<app-lp-navbar></app-lp-navbar>
<app-hero-section></app-hero-section>
<app-experience-section></app-experience-section>
<app-features-section></app-features-section>
<app-cta-section></app-cta-section>
<app-lp-footer></app-lp-footer>
